import { JSXMapSerializer } from "@prismicio/react"
import RiExternalLinkLine from '~icons/ri/external-link-line'
import Image from "next/image"
import Link from "next/link"

export const embedSerializer: JSXMapSerializer = {
  embed: ({ node, children , key}) => (
    <Link
      key={key}
      target="_blank"
      href={node.oembed.embed_url}
      className={'flex flex-row items-center rounded-xl overflow-hidden bg-gradient-to-r from-[#0B0B0B] to-[#0B0B0B] to-95% hover:from-[#0B0B0B] hover:to-zinc-900'}>
      <Image
        src={node.oembed.thumbnail_url!}
        alt={`Превью ролика или плейлиста по игре ${node.oembed.title}`}
        width={256}
        height={96}
        className='object-cover' style={{height: '86px'}}/>
      <section className={'flex flex-row gap-4 justify-between items-center w-full px-5'}>
        <div>
          <p className={'text-sm font-bold'}>{node.oembed.embed_url.includes('playlist') === true ? 'Плейлист' : 'Видео'}</p>
          <p className={'text-sm line-clamp-1'}>{node.oembed.title}</p>
        </div>
        <div><RiExternalLinkLine className={'w-8'}/></div>
      </section>
    </Link>
  ),
  hyperlink: ({ node, text, children, key}) => (
    <a
      key={key}
      href={node.data.url}
      className={'text-sm text-zinc-500 bg-[#0B0B0B] px-2 py-1 rounded-xl'}>{text}</a>
  ),
  image: ({ node, text, children, key}) => (
    <Image
      src={node.url}
      alt={node.alt !== null ? node.alt : 'Изображение в обзоре'}
      width={node.dimensions.width}
      height={node.dimensions.height}
      className={'rounded-2xl'}
    />
  )
}